// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__3q_o_","buttons":"styles_buttons__8ovO4"};